var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useRef, useMemo, useState, useEffect, createContext } from 'react';
import cx from 'classnames';
import styles from './styles.module.scss';
import { useClickOutside } from '../../../small-tools/use-click-outside';
export var DropdownContext = createContext(undefined);
export var Dropdown = function (_a) {
    var children = _a.children, controlledIsOpen = _a.isOpen, defaultOpen = _a.defaultOpen, onToggle = _a.onToggle, controlled = _a.controlled, className = _a.className, rest = __rest(_a, ["children", "isOpen", "defaultOpen", "onToggle", "controlled", "className"]);
    var _b = useState(defaultOpen), isOpen = _b[0], setIsOpen = _b[1];
    var containerRef = useRef(null);
    var actualIsOpen = controlled ? controlledIsOpen : isOpen;
    var toggleDropdown = function () {
        var newState = !actualIsOpen;
        if (controlled) {
            onToggle === null || onToggle === void 0 ? void 0 : onToggle(!actualIsOpen);
        }
        else {
            setIsOpen(newState);
        }
    };
    useClickOutside(containerRef, function () {
        if (isOpen && !controlled) {
            setIsOpen(false);
        }
    });
    useEffect(function () {
        if (controlled && typeof controlledIsOpen === 'boolean') {
            setIsOpen(controlledIsOpen);
        }
    }, [controlledIsOpen, controlled]);
    var contextValue = useMemo(function () { return ({
        isOpen: actualIsOpen,
        toggleDropdown: toggleDropdown,
    }); }, [actualIsOpen, toggleDropdown]);
    return (_jsx(DropdownContext.Provider, { value: contextValue, children: _jsx("div", __assign({ className: cx(styles.container, className), ref: containerRef }, rest, { children: children })) }));
};
Dropdown.defaultProps = {
    defaultOpen: false,
    controlled: false,
    isOpen: undefined,
    onToggle: undefined,
    className: '',
};
